Q         = require('q')
_         = require('underscore')
Rollbar   = require('rollbar-browser')
config    = require('./config')


# settings
enabled       = config.environment == 'staging' || config.environment == 'production'
# enabled       = true
retryMs       = 60000
# retryMs       = 15000


# internal
queue         = []
idMapping     = {}
rollbar       = null
storeKey      = 'appRollbarQueue'
_retryTimeout = null


# Public method to report error to rollbar
reportError = (name, message, stack, error) ->
  # log('error', "#{name}: #{message}", error)
  log
    level:    'error'
    message:  "#{name}: #{message}"
    error:    error


# Generic log method
log = (options = {}) ->
  return unless enabled == true

  internalQueueId = _.uniqueId('rollbar')
  level           = options.level
  message         = options.message || null
  error           = options.error || null
  custom          = options.custom || {}

  # Ensure second argument is object with internal_queue_id set
  custom.internal_queue_id = internalQueueId

  # build params
  params = []
  params.push level
  params.push message                 if _.isString(message)
  params.push error.message           if _.size(params) == 0 && _.isError(error)
  params.push error                   if _.isError(error)
  params.push new Error('No Message') if _.size(params) == 0
  params.push custom
  params.push (error, data) => rollbarCallback(internalQueueId, error, data)

  # Call rollbar function with adjusted arguments
  rollbar.log.apply(rollbar, params)

  # Since we're using { async: true } settings in rollbar, we can
  # touch the rollbar queue and add the payloads to our interal queue
  _.each window._rollbarPayloadQueue, (payload) => _addPayload(payload)


# rollbar callback
rollbarCheckIgnoreCallback = (isUncaught, args, payload) ->
  if isUncaught == true

    # meaningless "Script errors"
    if (args[0]? && args[0].indexOf('Script error') == 0) || (args[1]? && args[1].indexOf('Script error') == 0)
      return true

    false
  else
    false


# rollbar general callback
rollbarCallback = (internalQueueId, error, data) ->
  if error
    rollbarCallbackError(error, internalQueueId)
  else
    rollbarCallbackSuccess(data.result, internalQueueId)

# rollbar callback - error
rollbarCallbackError = (error, internalQueueId) ->
  _retryTimeout or= window.setTimeout ->
    _retryTimeout = null
    retrySendPayloadQueue()
  , retryMs

# rollbar callback - success
rollbarCallbackSuccess = (data, internalQueueId) ->
  queue = _.filter queue, (data) =>
    if data.payload.data.body.message
      d = data.payload.data.body.message
    else
      d = data.payload.data.body.trace

    uuid = data.payload.data.uuid
    quid = d.extra.internal_queue_id

    # keep in queue if it doesn't match with the current internalQueueId
    return true if quid != internalQueueId

    # remove additionally from idMapping object
    delete idMapping[uuid] if idMapping[uuid]
    false

  _writeLocalStorage()

# retry sending
retrySendPayloadQueue = ->
  return unless enabled == true
  return unless _.any(queue)

  window._rollbarPayloadQueue = window._rollbarPayloadQueue.concat(queue)

  try
    RollbarNotifier.processPayloads()
  catch e
    # do nothing...

# Add payload to local queue
_addPayload = (payload, write = true) ->
  return if _isPayloadStored(payload)

  if payload.payload.data.body.message
    d = payload.payload.data.body.message
  else
    d = payload.payload.data.body.trace

  idMapping[payload.payload.data.uuid] = d.extra.internal_queue_id
  queue.push(payload)

  _writeLocalStorage() if write == true


# Check if a payload is already in local queue
_isPayloadStored = (payload) ->
  stored = _.find queue, (p) -> p.payload.data.uuid == payload.payload.data.uuid

  !_.isUndefined(stored) && !_.isNull(stored)


# Read payloads queue from local storage
_readLocalStorage = ->
  data = localStorage.getItem(storeKey)
  return unless _.isString(data) && data != ''

  data = JSON.parse(data)
  return unless _.isArray(data)

  _.each data, (payload) => _addPayload(payload, false)


# Write payloads queue to local storage
_writeLocalStorage = ->
  localStorage.setItem(storeKey, JSON.stringify(queue))


# ------------------------------------------------------------
# init

rollbar = Rollbar.init
  async:                      true
  enabled:                    config.rollbar.enabled
  accessToken:                config.rollbar.client_key
  # captureUncaught:            enabled
  checkIgnore:                rollbarCheckIgnoreCallback
  payload:
    environment: config.environment
    client:
      javascript:
        source_map_enabled:     true
        guess_uncaught_frames:  true
        code_version:           config.revision
    person:
      id:     config.current_user?.id || null
      email:  config.current_user?.email || null

if enabled == true
  _readLocalStorage()
  setTimeout retrySendPayloadQueue, 500

# ------------------------------------------------------------
# export

module.exports =
  reportError:  reportError
  log:          log




// WEBPACK FOOTER //
// ./assets/js/shared/util/error/rollbar.coffee